import { useSelector } from 'react-redux'
import { messagesSelectors, selectMessages } from 'store/messages'
import { ChatResponseModeEnum, ChatRoleEnum } from 'types/chat'
import { UserMessage } from 'components/messages/UserMessage'
import { TicketInfoCard } from 'components/ui/TicketInfoCard'
import { OperatorMessage } from 'components/messages/OperatorMessage'
import { BotMessage } from 'components/messages/BotMessage'
import { useCallback, useMemo } from 'react'
import _ from 'lodash'
import { ChatMessage } from 'types/chat-message'

export const ChatMessages = () => {
  const messages = useSelector(selectMessages)
  const currentChatTicket = useSelector(messagesSelectors.currentChatTicket)

  const lastMessageInBotMode = useMemo(() => {
    if (!currentChatTicket) {
      return undefined
    }
    const message = _.findLast(messages, (message) => message.chatResponseMode === ChatResponseModeEnum?.BOT)
    return message?._id
  }, [messages, currentChatTicket])

  const renderMessage = useCallback(
    (message: ChatMessage, i: number) => {
      const isOperator = message.chatSenderRole === ChatRoleEnum.OPERATOR
      const isBot = message.chatSenderRole === ChatRoleEnum.BOT
      const isUser = [ChatRoleEnum.USER, ChatRoleEnum.GUEST].includes(message.chatSenderRole)
      const isLastMessageInBotMode = lastMessageInBotMode === message._id

      const result = []
      if (isUser) {
        result.push(<UserMessage messageItem={message} key={message._id} />)
      }
      if (isOperator) {
        result.push(
          <OperatorMessage
            messageItem={message}
            key={message._id}
            index={i}
            startsSequence={true}
            endsSequence={false}
          />,
        )
      }
      if (isBot) {
        result.push(
          <BotMessage messageItem={message} key={message._id} index={i} startsSequence={true} endsSequence={false} />,
        )
      }
      if (isLastMessageInBotMode) {
        result.push(<TicketInfoCard key={'ticket-info'} />)
      }

      return result
    },
    [lastMessageInBotMode],
  )

  return <div className={'tw-flex tw-flex-col tw-gap-3'}>{messages.map(renderMessage)}</div>
}
